import type { PanelContribution } from '@/shared/registry'

import { classSlots } from '../slots'

/**
 * The class form's sections that Classes adds itself, in the form's order, one line per item.
 * Each sits in `classSlots.formSections`, beside other areas' sections.
 */
export const classFormSections: readonly PanelContribution[] = [
  { kind: 'panel', slot: classSlots.formSections, id: 'custom-fields', component: () => import('../custom-fields/ClassCustomFieldsSection').then((module) => module.ClassCustomFieldsSection) },
  { kind: 'panel', slot: classSlots.formSections, id: 'microsoft-learn-links', component: () => import('./microsoft-learn/MicrosoftLearnLinksFields').then((module) => module.MicrosoftLearnLinksFields) },
]
